export default "__VITE_ASSET__Ba9OG$CL__"